import { json, checkStatus, CustomerAPI, IntegrationAPI } from '@driftt/dapper'

export const api = {
  fetchEloquaMappings() {
    return IntegrationAPI.get('/eloqua/mappings/attributes')
      .then(json)
  },

  patchEloquaMappings(mappings) {
    return IntegrationAPI.patch('/eloqua/mappings/attributes', mappings)
      .then(checkStatus)
      .then(json)
  },

  fetchEloquaFields() {
    return IntegrationAPI.get('/eloqua/contact/fields')
      .then(checkStatus)
      .then(json)
  },

  fetchEloquaCDOs(query) {
    return IntegrationAPI.get(`/eloqua/custom_object/list?query=${query}&limit=50`)
      .then(checkStatus)
      .then(json)
  },

  fetchEloquaCdoConfig() {
    return IntegrationAPI.get('/eloqua/cdo/config')
      .then(checkStatus)
      .then(json)
  },

  patchEloquaCdoConfig(updates) {
    return IntegrationAPI.patch('/eloqua/cdo/config', updates)
      .then(checkStatus)
      .then(json)
  },

  fetchEloquaCdoFields() {
    return IntegrationAPI.get('/eloqua/cdo/fields')
      .then(checkStatus)
      .then(json)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/eloqua/api.js